import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import axios from 'axios';
import router from './routes';
import firebase from './plugins/firebase';
import Notifications from 'vue-notification';
import VueTheMask from 'vue-the-mask';
import VueFriendlyIframe from 'vue-friendly-iframe';
import '@fortawesome/fontawesome-free/css/all.css';
import 'slick-carousel/slick/slick.css';
import { FormatDate, FormatMoney, FormatDateTime } from './filters';
const DeviceUUID = require("device-uuid");

window.DeviceUUID = DeviceUUID.DeviceUUID();
window.TRAINING = null;
window.CONVERSATION = null;
window.USER = null;
window.USER_ID = null;
window.MODULES = null;
window.MODULE = null;
window.ACTIVITIES = null;
window.SERVE = "https://profkenny.com.br/api";

Vue.config.productionTip = false;
Vue.use(Notifications);

//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// GLOBAL VARIABLES
Vue.prototype.$db = firebase.firestore;
Vue.prototype.$auth = firebase.auth;

Vue.prototype.$SERVE = "https://profkenny.com.br/api";
Vue.prototype.$SITE = "https://profkenny.com.br";
Vue.prototype.$http = axios;

// MENU HEADER
Vue.component('header-menu', () => import('./HeaderMenu.vue'));
Vue.component('footer-page', () => import('./components/Footer.vue'));

Vue.component('header-status', () => import('./components/HeaderStatus.vue'));
Vue.component('list-lessons', () => import('./components/ListLessons.vue'));
Vue.component('list-training', () => import('./components/ListTraining.vue'));
Vue.component('list-conversation', () => import('./components/ListConversation.vue'));
Vue.component('chat-message', () => import('./components/ChatMessageComponent.vue'));

// COMPONENTS
Vue.component('dialog-loader', () => import('./components/DialogLoaderComponent.vue'));
Vue.component('vue-friendly-iframe', VueFriendlyIframe);

Vue.filter('formatMoney', FormatMoney);
Vue.filter('formatDate', FormatDate);
Vue.filter('formatDateTime', FormatDateTime);

Vue.use(VueTheMask);
Vue.use(require('vue-chat-scroll'));

new Vue({
  vuetify, // we add vuetify here
  router,
  render: (h) => h(App)
}).$mount('#app');
